<!-- 譲渡前のダイアログ -->
<template>
  <div>
    <!-- 購買解除の確認ダイアログ -->
    <ItemDialog ref="stopSubscriptionDialog" image-type="alert">
      <template #content-area>
        <p>
          チケットの自動更新（継続課金）を停止します。停止後は元に戻せません。よろしいですか？
        </p>
      </template>
      <template #button-area>
        <ItemButton
          label="OK"
          action-type="btn-primary"
          @clicked="stopSubscription"
        />

        <ItemButton
          label="キャンセル"
          action-type="btn-cancel"
          @clicked="closeDialog"
        />
      </template>
    </ItemDialog>
    <!-- 購買解除の確認ダイアログ -->

    <!-- 購買解除完了のダイアログ 使うタグへ戻るネイティブコール -->
    <ItemDialog ref="doneUnsubscription" image-type="done">
      <template #content-area>
        <p>チケット有効期間の自動更新（継続課金）を停止しました。</p>
      </template>
      <template #button-area>
        <ItemButton
          label="OK"
          action-type="btn-primary"
          @clicked="returnNativeAppMyticketPage"
        />
      </template>
    </ItemDialog>
    <!-- 購買解除完了のダイアログ -->

    <!-- ローディングダイアログ -->
    <DialogLoading ref="DialogLoading" />
  </div>
</template>

<script>
import API from "@/API";
export default {
  name: "DialogStopSubscriptionDialog",
  methods: {
    openDialog() {
      this.$refs.stopSubscriptionDialog.open();
    },
    closeDialog() {
      this.$refs.stopSubscriptionDialog.close();
    },
    // 購買のストップ
    async stopSubscription() {
      this.$refs.stopSubscriptionDialog.close();
      this.$refs.DialogLoading.openDialog();

      await API.postStopSubscription(this.$route.params.book_group_id);

      this.$refs.DialogLoading.closeDialog();
      this.$refs.doneUnsubscription.open();
    },
  },
};
</script>
